<template>
    <div id="main">
        <div>
            <h3 class="titleChannel"> <i class="fa-solid fa-list"></i> Doanh thu & Hóa đơn</h3>
        </div>
        <div class="ml-2">
            <div>
                <div class="row m-0 pb-2 d-flex justify-content-start flex-wrap container-search-sort" id="search-sort">
                    <div class="col col-md-1 pl-0 wrap-paginate" id="page">
                        <select content="Phân trang" v-tippy class="form-control" v-model="big_search.per_page">
                            <option value="5">5</option>
                            <option value="10">10</option>
                            <option value="15">15</option>
                            <option value="20">20</option>
                        </select>
                    </div>
                    <div class="col col-md-2 pl-0 wrap-sortby">
                        <select content="Tính toán theo" v-tippy class="form-control "
                            v-model="big_search.category_filter">
                            <option value="month">Tháng</option>
                            <option value="quarter">Quý</option>
                            <option value="year">Năm</option>
                        </select>
                    </div>
                    <div class="col col-md-2 pl-0 wrap-typesort">
                        <select content="Chọn Năm" v-tippy class="form-control " v-model="big_search.year">
                            <option v-for="year in years" :key="year" :value="year">
                                Năm {{ year }}
                            </option>
                        </select>
                    </div>
                    <div v-if="big_search.category_filter === 'quarter'" class="col col-md-2 pl-0 wrap-typesort">
                        <select content="Chọn Quý" v-tippy class="form-control " v-model="big_search.quarterly">
                            <option v-for="q in 4" :key="q" :value="q">
                                Quý {{ q }}
                            </option>
                        </select>
                    </div>
                    <div v-if="big_search.category_filter === 'month'" class="col col-md-2 pl-0 wrap-typesort">
                        <select content="Chọn Tháng" v-tippy class="form-control " v-model="big_search.month">
                            <option v-for="m in 12" :key="m" :value="m">
                                Tháng {{ m }}
                            </option>
                        </select>
                    </div>
                </div>
                <div class="mb-2 mt-2 infor-revenue">
                    <p><i class="fa-solid fa-coins"></i> Tổng doanh thu: <span class="text-primary">{{ this.$formatNumber(sum_revenue) }} VNĐ</span> </p>
                    <p><i class="fa-solid fa-coins"></i> Tổng VAT: <span class="text-danger">{{ this.$formatNumber(sum_vat_amount) }} VNĐ</span></p>
                    <p><i class="fa-solid fa-coins"></i> Tổng lợi nhuận: <span class="text-success">{{ this.$formatNumber(sum_profit) }} VNĐ</span></p>
                </div>
                <div v-if="isLoading">
                    <TableLoading :cols="8" :rows="9"></TableLoading>
                </div>
                <div v-if="!isLoading" class="tableData">
                    <table class="table table-bordered">
                        <thead>
                            <tr>
                                <th scope="col">#</th>
                                <th scope="col">Tên học viên</th>
                                <th scope="col">Doanh thu thực (VNĐ)</th>
                                <!-- <th class="remove-column" scope="col">VAT(%)</th>
                                <th class="remove-column" scope="col">VAT(VNĐ)</th>
                                <th class="remove-column" scope="col">Lợi nhuận (VNĐ)</th> -->
                                <th scope="col" class="remove-column"><i class="fa-solid fa-quote-left"></i> Note</th>
                                <th scope="col"><i class="fa-solid fa-user-pen"></i> Action</th>
                                <th scope="col">Ngày tạo</th>
                                <th scope="col">Ngày cập nhật</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(record, index) in invoices" :key="index">
                                <th class="table-cell" scope="row">#{{ (big_search.page - 1) * big_search.per_page +
                                    index + 1 }}</th>
                                <td class="table-cell text-center ">{{ record.user.name }}</td>
                                <td class="table-cell text-center  text-primary">{{ this.$formatNumber(record.revenue) }}</td>
                                <!-- <td class="remove-column table-cell text-center  text-danger">{{ this.$formatNumber(record.vat_percentage) }}</td>
                                <td class="remove-column table-cell text-center  text-danger">{{ this.$formatNumber(record.vat_amount) }}</td>
                                <td class="remove-column table-cell text-center  text-success">{{ this.$formatNumber(record.profit) }}</td> -->
                                <td class="table-cell text-center remove-column">
                                    <textarea style="width: 100%;" name="" id="" v-model="record.note"></textarea>
                                </td>
                                <td class="table-cell text-center">
                                    <div class="action action-5btn">
                                        <button data-toggle="modal" data-target="#viewRecord"
                                            v-tippy="{ content: 'Xem chi tiết' }" class="viewRecord"
                                            @click="selectedRecord(record)">
                                            <i class="fa-solid fa-eye"></i>
                                        </button>
                                        <button data-toggle="modal" data-target="#updateRecord"
                                            v-tippy="{ content: 'Chỉnh sửa' }" class="updateRecord"
                                            @click="selectedRecord(record)">
                                            <i class="fa-solid fa-pen-to-square"></i>
                                        </button>
                                    </div>
                                </td>
                                <td class="table-cell text-center">{{ this.$formatDate2(record.created_at) }}</td>
                                <td class="table-cell text-center">{{ this.$formatDate2(record.updated_at) }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div id="divpaginate" class="mt-2">
                    <paginate v-if="paginateVisible" :page-count="last_page" :page-range="3" :margin-pages="1"
                        :click-handler="clickCallback" :initial-page="big_search.page" :prev-text="'Prev'"
                        :next-text="'Next'" :container-class="'pagination'" :page-class="'page-item'">
                    </paginate>
                </div>
                <ViewRecord :recordSelected="recordSelected"></ViewRecord>
                <UpdateRecord :recordSelected="recordSelected"></UpdateRecord>
            </div>
        </div>
    </div>
</template>
<script>
import UserRequest from '@/restful/UserRequest';
import Paginate from 'vuejs-paginate-next';
import config from '@/config';
import TableLoading from '@/components/common/TableLoading'
import ViewRecord from '@/components/user/manage-invoice/ViewRecord.vue'
import UpdateRecord from '@/components/user/manage-invoice/UpdateRecord.vue'

export default {
    name: "ManageInvoice",
    components: {
        paginate: Paginate,
        TableLoading,
        ViewRecord,
        UpdateRecord,
    },
    setup() {
        document.title = "Doanh thu & Hóa đơn | Techbim"
    },
    data() {
        return {
            years: this.generateYears(),
            currentYear: null,
            currentMonth: null,
            currentQuarter: null,
            config: config,
            total: 0,
            last_page: 1,
            paginateVisible: true,
            big_search: {
                per_page: 5,
                page: 1,
                category_filter: 'month',
                year: 2025,
                quarterly: 1,
                month: 1,
            },
            query: '',
            invoices: [],
            sum_revenue: 0,
            sum_vat_amount: 0,
            sum_profit: 0,
            recordSelected: {
                id: null,
                user: {
                    name: null,
                    email: null,
                },
                revenue: 0,
                vat_percentage: 0,
                vat_amount: 0,
                profit: 0,
                name_courses: [],
                created_at: null,
                updated_at: null,
            },
            isLoading: false,
            user: {
                id: null,
                email: null,
                google_id: null,
                is_have_password: null,
                user_name: null,
                role: null,
                is_delete: null,
                is_block: null,
                name: null,
                phone: null,
                email_verified_at: null,
                created_at: null,
                updated_at: null,
                access_token: null,
                token_type: null,
                expires_in: null,
            },
        }
    },
    mounted() {
        this.$emitEvent('eventTitleHeader', 'Doanh thu & Hóa đơn');
        this.$emitEvent('eventActiveTab', '');
        this.setCurrentTime();
        const queryString = window.location.search;
        const searchParams = new URLSearchParams(queryString);
        this.big_search = {
            per_page: parseInt(searchParams.get('per_page')) || 5,
            page: searchParams.get('page') || 1,
            category_filter: searchParams.get('category_filter') || 'month',
            year: searchParams.get('year') || this.currentYear,
            quarterly: searchParams.get('quarterly') || this.currentQuarter,
            month: searchParams.get('month') || this.currentMonth,
        }
        this.getDataRecords();
        this.$onEvent('eventRegetDataRecords', () => {
            this.getDataRecords();
        });
    },

    methods: {
        generateYears() {
            const years = [];
            for (let i = 2024; i <= 2100; i++) {
                years.push(i);
            }
            return years;
        },
        setCurrentTime() {
            const now = new Date();
            // Năm hiện tại
            const currentYear = now.getFullYear();
            this.currentYear = currentYear;
            // Tháng hiện tại (1 → 12)
            const currentMonth = now.getMonth() + 1; // getMonth() trả về 0-11
            this.currentMonth = currentMonth;
            // Quý hiện tại (1 → 4)
            const currentQuarter = Math.floor((currentMonth - 1) / 3) + 1;
            this.currentQuarter = currentQuarter;
        },
        reRenderPaginate: function () {
            if (this.big_search.page > this.last_page) this.big_search.page = this.last_page;
            this.paginateVisible = false;
            this.$nextTick(() => { this.paginateVisible = true; });
        },
        getDataRecords: async function () {
            this.isLoading = true;
            this.query = `?category_filter=${this.big_search.category_filter}&year=${this.big_search.year}`
                + `&quarterly=${this.big_search.quarterly}&month=${this.big_search.month}`
                + `&page=${this.big_search.page}&per_page=${this.big_search.per_page}`;
            window.history.replaceState({}, null, this.query);
            try {
                const { data } = await UserRequest.get('admin/invoice/get-data' + this.query)
                console.log(data);
                this.invoices = data.invoices.data;
                this.total = data.invoices.total;
                this.last_page = data.invoices.last_page;
                this.sum_revenue = data.sum_revenue;
                this.sum_vat_amount = data.sum_vat_amount;
                this.sum_profit = data.sum_profit;
                this.isLoading = false;
            }
            catch (error) {
                if (error.messages) this.$emitEvent('eventError', error.messages[0]);
                this.isLoading = false;
            }
            this.reRenderPaginate();
        },

        clickCallback: function (pageNum) {
            this.big_search.page = pageNum;
        },

        selectedRecord: async function (record) {
            this.$emitEvent('eventSelectedRecord', record);
            this.recordSelected = record;
            console.log(this.recordSelected);
        },

    },
    watch: {
        big_search: {
            handler: function () {
                this.getDataRecords();
            },
            deep: true
        },
    }
}
</script>

<style src="./invoice-responsive.css"></style>
<style scoped>
.infor-revenue {
    font-weight: bold;
}

.div_microphone {
    cursor: pointer;
}

.titleChannel {
    font-size: 19px;
    color: var(--user-color);
}

tr th {
    color: var(--user-color);
}

.colorTitle {
    color: gray;
}

.tableData {
    min-height: 20vh;
    overflow-y: scroll;
}

.coverRecord {
    display: flex;
    align-items: center;
    align-content: center;
}

.deleteRecord .fa-trash:hover {
    transition: all 0.5s ease;
    color: red;
}

.deleteRecord .fa-trash-arrow-up:hover {
    transition: all 0.5s ease;
    color: green;
}

.deleteRecord {
    transition: all 0.5s ease;
    font-size: 20px;
}

.viewRecord,
.updateRecord {
    transition: all 0.5s ease;
    font-size: 20px;
}

.viewRecord i:hover {
    transition: all 0.5s ease;
    color: #007BFF;
}

.updateRecord i:hover {
    transition: all 0.5s ease;
    color: #007BFF;
}

.lockRecord {
    transition: all 0.5s ease;
    font-size: 20px;
}

.lockRecord .fa-lock:hover {
    transition: all 0.5s ease;
    color: red;
}

.lockRecord .fa-lock-open:hover {
    transition: all 0.5s ease;
    color: green;
}

.coverRecord img {
    border-radius: 6px;
    max-height: 100px;
}

.nameMember {
    margin-left: 10px;
}

#main {
    padding: 10px 20px;
    /* min-width: 375px !important; */
}

#page {
    margin-right: auto;
    min-width: 78px;
}

table {
    font-size: 12px;
}

table img {
    width: 200px;
    /* height:200px; */
    object-fit: cover;
}

.table-cell {
    font-weight: bold;
    vertical-align: middle;
}

table button {
    padding: 1px 3px;
    margin-right: 2px;
}

table thead th {
    vertical-align: middle;
    text-align: center;
}

.action {
    display: flex;
    align-items: center;
    justify-content: center;
}

.form-control {
    height: calc(1.5em + .5rem + 2px);
    padding: .25rem .5rem;
    font-size: .875rem;
    border-radius: 0.2rem;
    line-height: 1.5;
}

@media screen and (min-width: 1201px) {
    table {
        max-width: 100%;
        vertical-align: middle;
    }

    .coverRecord {
        min-width: 150px;
    }

    .displaytext {
        min-width: 150px;
        overflow: hidden;
        -webkit-line-clamp: 3 !important;
        -webkit-box-orient: vertical;
    }

    table img {
        min-width: 60px;
        min-height: 60px;
        /* max-width: 60px; */
        /* max-height: 60px; */
        object-fit: cover;
    }

    td .fa-solid {
        font-size: 20px;
    }

}

@media screen and (max-width: 1200px) {
    table {
        max-width: 100%;
        vertical-align: middle;
    }

    .coverRecord {
        min-width: 120px;
    }

    .displaytext {
        min-width: 100px;
        overflow: hidden;
        -webkit-line-clamp: 3 !important;
        -webkit-box-orient: vertical;

    }

    .break {
        word-break: break-all;
    }

    table {
        font-size: 11px;
    }

    .fa-solid {
        font-size: 15px;
    }

    table img {
        min-width: 50px;
        min-height: 50px;
        /* max-width: 50px;
        max-height: 50px; */
        object-fit: cover;
    }

    .table td,
    .table th {
        padding: 8px;
    }

    .form-control,
    .pagination {
        font-size: 12px !important;
    }

    #main {
        padding: 1% 1%;
        margin: 0;
    }
}

@media screen and (max-width: 992px) {
    .titleChannel {
        font-size: 15px;
    }

    .colorTitle {
        font-size: 14px;
    }

    table {
        max-width: 100%;
        vertical-align: middle;
    }

    .coverRecord {
        min-width: 140px;
    }

    .displaytext {
        min-width: 110px;
        overflow: hidden;
        -webkit-line-clamp: 3 !important;
        -webkit-box-orient: vertical;

    }

    .break {
        word-break: break-all;
    }

    table {
        font-size: 11px;
    }

    .fa-solid {
        font-size: 16px;
    }

    table img {
        min-width: 50px;
        min-height: 50px;
        /* max-width: 50px;
        max-height: 50px; */
        object-fit: cover;
    }

    .table td,
    .table th {
        padding: 8px;
    }

    .form-control,
    .pagination {
        font-size: 12px !important;
    }

    #main {
        padding: 1% 1%;
        margin: 0;
    }

    .col-1,
    .col-2,
    .col-3 {
        padding-left: 0;
        padding-right: 10px;
    }

    .btn {
        padding: 0px 4px;
        margin-top: 3px;
    }

    .input-group-text {
        padding: 0 8px;
    }
}

@media screen and (max-width: 768px) {

    .titleChannel,
    .colorTitle {
        font-size: 13px;
    }

    table {
        max-width: 100%;
        vertical-align: middle;
    }

    .coverRecord {
        min-width: 100px;
    }

    .displaytext {
        min-width: 90px;
        overflow: hidden;
        -webkit-line-clamp: 3 !important;
        -webkit-box-orient: vertical;

    }

    .break {
        word-break: break-all;
    }

    table {
        font-size: 11px;
    }

    .fa-solid {
        font-size: 13px;
    }

    table img {
        min-width: 40px;
        min-height: 40px;
        /* max-width: 40px;
        max-height: 40px; */
        object-fit: cover;
    }

    .table td,
    .table th {
        padding: 5px;
    }

    .form-control,
    .pagination {
        font-size: 12px !important;
    }

    #page {
        min-width: 45px;
    }

    .form-control {
        padding: 1px 1px;
    }

    #main {
        padding: 1% 1%;
        margin: 0;
    }

    .col-1,
    .col-2,
    .col-3 {
        padding-right: 5px;
    }

    .btn {
        padding: 0px 4px;
        margin-top: 3px;
    }

    .input-group-text {
        padding: 0 4px;
    }

    .input-group-prepend {
        font-size: 12px;

    }
}

@media screen and (max-width: 576px) {

    .titleChannel,
    .colorTitle {
        font-size: 12px;
    }

    table {
        max-width: 100%;
        vertical-align: middle;
    }

    .nameMember {
        margin-left: 8px;
    }

    .coverRecord {
        min-width: 100px;
    }

    .displaytext {
        min-width: 70px;
        overflow: hidden;
        -webkit-line-clamp: 3 !important;
        -webkit-box-orient: vertical;

    }

    .break {
        word-break: break-all;
    }

    table {
        font-size: 10px;
    }

    .fa-solid {
        font-size: 10px;
    }

    table img {
        min-width: 40px;
        min-height: 40px;
        /* max-width: 40px; */
        /* max-height: 40px; */
        object-fit: cover;
    }

    .table td,
    .table th {
        padding: 4px;
    }

    .form-control,
    .pagination {
        font-size: 10px !important;
    }

    .form-control {
        padding: 1px 1px;
        height: 25px;
    }

    #page {
        min-width: 45px;
    }

    #main {
        padding: 1% 1%;
        margin: 0;
    }

    .col-1,
    .col-2,
    .col-3 {
        padding-right: 5px;
    }

    .btn {
        padding: 0px 4px;
    }

    .input-group-text {
        padding: 0 0.5px;
    }

    .input-group-prepend {
        font-size: 11px;

    }
}

@media screen and (max-width: 424px) {

    .titleChannel,
    .colorTitle {
        font-size: 11px;
    }

    table {
        max-width: 100%;
        vertical-align: middle;
    }

    .nameMember {
        margin-left: 8px;
    }

    .coverRecord {
        min-width: 80px;
    }

    .displaytext {
        min-width: 70px;
        overflow: hidden;
        -webkit-line-clamp: 3 !important;
        -webkit-box-orient: vertical;

    }

    .break {
        word-break: break-all;
    }

    table {
        font-size: 9px;
    }

    .fa-solid {
        font-size: 10px;
    }

    table img {
        min-width: 40px;
        min-height: 40px;
        /* max-width: 40px;
        max-height: 40px; */
        object-fit: cover;
    }

    .table td,
    .table th {
        padding: 4px;
    }

    .form-control,
    .pagination {
        font-size: 9px !important;
    }

    .form-control {
        padding: 0.5px 0;
        height: 25px;
    }

    #page {
        min-width: 40px;
    }

    #main {
        padding: 1% 1%;
        margin: 0;
    }

    .col-1,
    .col-2,
    .col-3 {
        padding-right: 0;
    }

    .btn {
        padding: 0px 4px;
    }

    .input-group-text {
        padding: 0 0.5px;
    }

    .input-group-prepend {
        font-size: 10px;

    }

    #main .ml-2 {
        margin-left: 3px !important;
    }
}
</style>